var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPoser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8267 3.04627C14.5957 2.77125 14.2602 2.63377 13.9247 2.65581C13.9632 2.83177 13.9797 3.01328 13.9797 3.20029C13.9797 3.81079 13.7817 4.37181 13.4462 4.82829L14.3812 5.95033C14.2727 5.95033 9.85934 5.94514 9.75214 5.95894C8.73352 6.08675 7.86394 6.58496 7.23766 7.40028C5.58686 9.54924 6.04339 13.2937 6.10086 13.7138C6.17634 14.2649 6.64763 14.6639 7.18905 14.6639C7.85885 14.6639 8.36908 14.074 8.28071 13.4168C8.16095 12.5249 8.05405 9.94596 8.98406 8.7385C8.99841 8.71982 9.015 8.70664 9.02971 8.68888V12.5504V13.1004V21.9004C9.02971 22.5079 9.52222 23.0004 10.1297 23.0004C10.7372 23.0004 11.2297 22.5079 11.2297 21.9004V19.8258C11.417 19.9541 11.632 20.0213 11.8482 20.0213C12.1506 20.0213 12.4519 19.8972 12.6692 19.6536L15.9004 16.0327C16.2493 15.6419 16.274 15.0594 15.9598 14.6402L13.4297 11.2668V8.1503H16.7298C17.1588 8.1503 17.5438 7.90277 17.7253 7.51776C17.9068 7.13275 17.8463 6.67628 17.5767 6.34624L14.8267 3.04627ZM11.2297 17.9626V13.1003H12.0546L13.6593 15.2399L11.2297 17.9626Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2287 5.40019C12.4437 5.40019 13.4286 4.41526 13.4286 3.20028C13.4286 1.9853 12.4437 1.00037 11.2287 1.00037C10.0137 1.00037 9.02881 1.9853 9.02881 3.20028C9.02881 4.41526 10.0137 5.40019 11.2287 5.40019Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoser);
export default __webpack_public_path__ + "static/media/icon-poser.165a8b895bc01b5d506dac470ccad90d.svg";
export { ForwardRef as ReactComponent };